import './style.css';

const Header = () => (
  <header className="header">
    <h1>Monomoney</h1>
    {/* <nav>
      <Link activeClassName={style.active} href="/">
        Home
      </Link>
      <Link activeClassName={style.active} href="/profile">
        Me
      </Link>
      <Link activeClassName={style.active} href="/profile/john">
        John
      </Link>
    </nav> */}
  </header>
);

export default Header;
